import type { ReactNode} from "react";
import { createContext, useContext, useReducer } from "react";
import type { Dispatch } from "./Actions";
import { PlanningInitialState } from "../annotation/PlanningIntialState";
import type { PlaningFormData } from "../annotation/PlanningInterface";
import PlanningReducer from "./PlanningReducer";
import { useLocation } from "react-router-dom";

interface FormProviderProps {
    children: ReactNode;
}

const FormContext = createContext<
    | {
        state: PlaningFormData;
        dispatch: Dispatch;
        isViewMode: boolean;
    }
    | undefined
>(undefined);

export const useFormContext = () => {
    const context = useContext(FormContext);
    if (!context) {
        throw new Error("useFormContext must be used within a FormProvider");
    }
    return context;
};

export const FormProvider: React.FC<FormProviderProps> = ({ children }) => {
    const [state, dispatch] = useReducer(PlanningReducer, PlanningInitialState);
    const location = useLocation();

    // Determine isDisabled based on the URL (or other conditions)
    const isViewMode = location.pathname.includes("view");

    return (
        <FormContext.Provider value={{ state, dispatch, isViewMode }}>
            {children}
        </FormContext.Provider>
    );
};

